import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography
} from '@material-ui/core';
import getInitials from '../../utils/getInitials';
import React, { useCallback } from 'react';

const Book = ({ book, quotes }) => {

  const getLastQuoteDate = useCallback(() => {
    const ordered = quotes.sort((a, b) => {
      return new Date(b.created_at) - new Date(a.created_at);
    });

    const [last] = ordered;

    if (!last) {
      return '';
    }

    const date = new Date(last.created_at);

    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
  }, [quotes]);

  return (
    <Card>
      <CardContent>
        <Grid container spacing={4}>
          <Grid item xs={1}>
            <Avatar src={book.cover} sx={{ mr: 2 }}>
              {getInitials(book.title)}
            </Avatar>
          </Grid>
          <Grid item>
            <Typography>
              <b>ID do livro filho</b> <br /> {book.original_child_book_id ?? book.id}
            </Typography>
          </Grid>
          <Grid item>
            <Typography>
              <b>ID do livro pai</b> <br /> {book.main_book?.id ?? 'N/A'}
            </Typography>
          </Grid>
          <Grid item>
            <Typography>
              <b>Autor</b>
              <br /> {book.authors.map(author => author.name).join(',')}
            </Typography>
          </Grid>
          <Grid item>
            <Typography>
              <b>Título</b> <br /> {book.title}
            </Typography>
          </Grid>
          <Grid item>
            <Typography>
              <b>ISBN</b> <br /> {book.isbn}
            </Typography>
          </Grid>
          <Grid item>
            <Typography>
              <b>Qtde. de trechos</b> <br /> {quotes.length}
            </Typography>
          </Grid>
          <Grid item>
            <Typography>
              <b>Última utilização</b><br />{getLastQuoteDate()}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Book;
